import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import { useDispatch, useSelector } from 'react-redux';
import { errorHelper, Loader } from '../../utils/tools';
import { validation, formValues, CLIENT_CATEGORIES } from './validationSchema';

import { fetchClients, detailClient, editClient, canDeleteClient, deleteClient, addBranch, updateBranch, deleteBranch } from '../../store/actions/client';
import { getTenant } from '../../store/actions/tenant';

import CompanySearch from '../companySearch';

import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { COUNTRIES } from '../../utils/constants/countries';


const EditClient = ({ client, onClose }) => {

    let navigate = useNavigate();

    const currentCompany = useSelector(state => state.companySearch.current);
    const branchId = useSelector(state => state.branch.current);

    useEffect(() => {
        if (isAbroad) return;
        formik.setFieldValue('companyName', currentCompany.companyName || '');
        formik.setFieldValue('address.street', currentCompany.street || "");
        formik.setFieldValue('address.zip', currentCompany.zip || '');
        formik.setFieldValue('address.city', currentCompany.city || '');
        formik.setFieldValue('address.country', currentCompany.coutry || 'Slovensko');
        formik.setFieldValue('identificationNumber', currentCompany.identificationNumber || '');
        formik.setFieldValue('vatId', currentCompany.vatId || '');
        formik.setFieldValue('vatRegNo', currentCompany.vatRegNo || '');
    }, [currentCompany]);

    const notifications = useSelector(state => state.notifications);
    const currentClient = useSelector(state => state.client.current);
    const canDelete = useSelector(state => state.client.canDeleteCurrent);
    const loading = useSelector(state => state.client.currentClientLoading);

    const [isAbroad, setIsAbroad] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddBranch, setShowAddBranch] = useState(false);
    const [newBranch, setNewBranch] = useState({
        name: '',
        address: { street: '', zip: '', city: '', country: 'Slovensko' }
    });
    const [branchErrors, setBranchErrors] = useState({});
    const [branchToDelete, setBranchToDelete] = useState(null);
    const [branchToEdit, setBranchToEdit] = useState(null);
    const [editBranchData, setEditBranchData] = useState(null);
    const [editBranchErrors, setEditBranchErrors] = useState({});

    const dispatch = useDispatch();

    const handleAbroadToggle = (checked) => {
        setIsAbroad(checked);
        formik.setValues({
            ...formik.values,
            isAbroad: checked,
            address: {
                ...formik.values.address,
                country: checked ? '' : 'Slovensko',
            }
        }, false);
        formik.setTouched({}, false);
        setNewBranch(prev => ({
            ...prev,
            address: { ...prev.address, country: checked ? '' : 'Slovensko' }
        }));
    };

    useEffect(() => {
        if (currentClient) {
            dispatch(detailClient(client._id));
            dispatch(canDeleteClient(client._id));
        }
    }, [dispatch, client]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: formValues,
        validationSchema: validation(isAbroad),
        onSubmit: (values) => handleSubmit(values)
    });

    useEffect(() => {
        if (currentClient?.address?.country) {
            setNewBranch(prev => ({ ...prev, address: { ...prev.address, country: currentClient.address.country } }));
        }
    }, [currentClient]);

    useEffect(() => {
        if (currentClient.address) {
            const abroad = currentClient.isAbroad || false;
            setIsAbroad(abroad);
            formik.setValues({
                ...formik.values,
                isAbroad: abroad,
                companyName: currentClient.companyName,
                identificationNumber: currentClient.identificationNumber,
                vatId: currentClient.vatId,
                vatRegNo: currentClient.vatRegNo,
                contact: currentClient.contact,
                email: currentClient.email,
                categories: currentClient.categories && currentClient.categories.length ? currentClient.categories : formValues.categories,
                address: {
                    street: currentClient.address.street,
                    zip: currentClient.address.zip,
                    city: currentClient.address.city,
                    country: currentClient.address.country
                },
            });
        }
    }, [currentClient]);

    const toggleCategory = (value) => {
        const current = formik.values.categories || [];
        const next = current.includes(value) ? current.filter(c => c !== value) : [...current, value];
        formik.setFieldValue('categories', next);
    };

    const handleSubmit = (values) => {
        values.id = client._id;
        dispatch(editClient(values));
        onClose();
    };

    const handleDelete = async () => {
        await dispatch(deleteClient(client._id)).unwrap();
        await dispatch(getTenant(branchId)).unwrap();
        await dispatch(fetchClients()).unwrap();
        setShowDeleteModal(false);
        onClose();
    };

    const validateBranch = (branch) => {
        const errors = {};
        if (!branch.name || branch.name.trim().length < 1) errors.name = 'Názov je povinný.';
        if (!branch.address.street || branch.address.street.trim().length < 1) errors.street = 'Ulica je povinná.';
        if (isAbroad) {
            if (!branch.address.zip || branch.address.zip.trim().length < 3) errors.zip = 'PSČ musí mať aspoň 3 znaky.';
            else if (branch.address.zip.trim().length > 20) errors.zip = 'PSČ môže mať maximálne 20 znakov.';
        } else {
            if (!branch.address.zip || !/^\d{5}$/.test(branch.address.zip)) errors.zip = 'PSČ musí mať 5 číslic.';
        }
        if (!branch.address.city || branch.address.city.trim().length < 2) errors.city = 'Mesto je povinné.';
        if (!branch.address.country || branch.address.country.trim().length < 1) errors.country = 'Krajina je povinná.';
        return errors;
    };

    const handleAddBranch = async () => {
        const errors = validateBranch(newBranch);
        if (Object.keys(errors).length > 0) {
            setBranchErrors(errors);
            return;
        }
        setBranchErrors({});
        await dispatch(addBranch({ clientId: client._id, name: newBranch.name, address: newBranch.address })).unwrap();
        await dispatch(detailClient(client._id));
        setShowAddBranch(false);
        setNewBranch({ name: '', address: { street: '', zip: '', city: '', country: currentClient.address.country } });
    };

    const handleConfirmDeleteBranch = async () => {
        const result = await dispatch(deleteBranch({ clientId: client._id, branchId: branchToDelete._id })).unwrap();
        setBranchToDelete(null);
        if (result === true) {
            await dispatch(detailClient(client._id));
        }
    };

    const handleStartEditBranch = (branch) => {
        setBranchToEdit(branch);
        setEditBranchData({
            name: branch.name,
            address: { ...branch.address }
        });
        setEditBranchErrors({});
        setShowAddBranch(false);
    };

    const handleUpdateBranch = async () => {
        const errors = validateBranch(editBranchData);
        if (Object.keys(errors).length > 0) {
            setEditBranchErrors(errors);
            return;
        }
        setEditBranchErrors({});
        await dispatch(updateBranch({ clientId: client._id, branchId: branchToEdit._id, name: editBranchData.name, address: editBranchData.address })).unwrap();
        await dispatch(detailClient(client._id));
        setBranchToEdit(null);
        setEditBranchData(null);
    };

    return (
        <>
            {loading || !currentClient ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
                    <Loader />
                </div>
            ) : (
                <div>
                    <h2>Upraviť dodávateľa/odberateľa</h2>
                    <hr />

                    <Form
                        onSubmit={formik.handleSubmit}
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <div className="p-3 mb-4 rounded" style={{ background: '#f8f9fa', border: '1px solid #dee2e6' }}>
                            <Form.Check
                                type="switch"
                                id="isAbroad"
                                label={
                                    <span>
                                        Zahraničný odberateľ/dodávateľ
                                        <span className={`badge ms-2 ${isAbroad ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                            {isAbroad ? 'Zahraničný' : 'Slovenský'}
                                        </span>
                                    </span>
                                }
                                checked={isAbroad}
                                onChange={e => handleAbroadToggle(e.target.checked)}
                                className="mb-0"
                            />
                            {isAbroad && (
                                <small className="text-muted mt-1 d-block">
                                    Pre zahraničné firmy nie je dostupné automatické vyhľadávanie v obchodnom registri.
                                </small>
                            )}
                        </div>

                        <Form.Group className="mb-4">
                            <Form.Label>Kategória*</Form.Label>
                            <div className="d-flex gap-3">
                                {CLIENT_CATEGORIES.map(({ value, label }) => (
                                    <Form.Check
                                        key={value}
                                        type="checkbox"
                                        id={`edit-category-${value}`}
                                        label={label}
                                        checked={(formik.values.categories || []).includes(value)}
                                        onChange={() => toggleCategory(value)}
                                    />
                                ))}
                            </div>
                            {formik.touched.categories && formik.errors.categories && (
                                <div className="invalid-feedback d-block">{formik.errors.categories}</div>
                            )}
                        </Form.Group>

                        <Row>
                            <Col>
                                {!isAbroad ? (
                                    <CompanySearch formik={formik} />
                                ) : (
                                    <Form.Group className="mb-3" controlId="formBasicCompanyName">
                                        <Form.Label>Názov spoločnosti*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Zadajte názov spoločnosti"
                                            {...formik.getFieldProps('companyName')}
                                            isInvalid={errorHelper(formik, 'companyName').error}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errorHelper(formik, 'companyName').helperText}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                )}

                                <Form.Group className="mb-3" controlId="formBasicIdentificationNumber">
                                    <Form.Label>{isAbroad ? 'Registračné číslo*' : 'IČO*'}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={isAbroad ? 'Zadajte registračné číslo' : 'Zadajte IČO'}
                                        {...formik.getFieldProps('identificationNumber')}
                                        isInvalid={errorHelper(formik, 'identificationNumber').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'identificationNumber').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicVatId">
                                    <Form.Label>DIČ</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Zadajte DIČ"
                                        {...formik.getFieldProps('vatId')}
                                        isInvalid={errorHelper(formik, 'vatId').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'vatId').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicVatRegNo">
                                    <Form.Label>DIČ DPH</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Zadajte DIČ DPH"
                                        {...formik.getFieldProps('vatRegNo')}
                                        isInvalid={errorHelper(formik, 'vatRegNo').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'vatRegNo').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col style={{ paddingTop: isAbroad ? 0 : '1.85rem' }}>
                                <Form.Group className="mb-3" controlId="formBasicStreet">
                                    <Form.Label>Ulica*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ulica a číslo"
                                        {...formik.getFieldProps('address.street')}
                                        isInvalid={formik.touched.address?.street && formik.errors.address?.street}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.address?.street}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicZip">
                                    <Form.Label>PSČ*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={isAbroad ? 'PSČ / ZIP' : '00000'}
                                        {...formik.getFieldProps('address.zip')}
                                        isInvalid={formik.touched.address?.zip && formik.errors.address?.zip}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.address?.zip}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicCity">
                                    <Form.Label>Mesto*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Mesto"
                                        {...formik.getFieldProps('address.city')}
                                        isInvalid={formik.touched.address?.city && formik.errors.address?.city}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.address?.city}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicCountry">
                                    <Form.Label>Krajina*</Form.Label>
                                    {isAbroad ? (
                                        <>
                                            <CreatableSelect
                                                options={COUNTRIES}
                                                value={formik.values.address.country ? { value: formik.values.address.country, label: formik.values.address.country } : null}
                                                onChange={option => formik.setFieldValue('address.country', option ? option.value : '')}
                                                onBlur={() => formik.setFieldTouched('address.country', true)}
                                                placeholder="Vyhľadať alebo vybrať krajinu..."
                                                formatCreateLabel={val => `Použiť: "${val}"`}
                                                isClearable
                                                noOptionsMessage={() => 'Žiadne výsledky'}
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: formik.touched.address?.country && formik.errors.address?.country ? '#dc3545' : state.isFocused ? '#86b7fe' : '#ced4da',
                                                        boxShadow: formik.touched.address?.country && formik.errors.address?.country ? '0 0 0 0.25rem rgba(220,53,69,.25)' : state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
                                                        '&:hover': { borderColor: formik.touched.address?.country && formik.errors.address?.country ? '#dc3545' : '#86b7fe' }
                                                    })
                                                }}
                                            />
                                            {formik.touched.address?.country && formik.errors.address?.country && (
                                                <div className="invalid-feedback d-block">
                                                    {formik.errors.address?.country}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            placeholder="Slovensko"
                                            {...formik.getFieldProps('address.country')}
                                            isInvalid={formik.touched.address?.country && formik.errors.address?.country}
                                        />
                                    )}
                                    {!isAbroad && (
                                        <Form.Control.Feedback type="invalid">
                                            {formik.errors.address?.country}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>

                        <hr className="mt-2 mb-3" />
                        <p className="fw-semibold mb-3">Kontaktná osoba</p>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicContact">
                                    <Form.Label>Telefón</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={isAbroad ? '+XXXXXXXXXXX' : '+421XXXXXXXXX'}
                                        {...formik.getFieldProps('contact')}
                                        isInvalid={errorHelper(formik, 'contact').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'contact').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Zadajte e-mail"
                                        {...formik.getFieldProps('email')}
                                        isInvalid={errorHelper(formik, 'email').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'email').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <strong>Prevádzkarne</strong>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => setShowAddBranch(!showAddBranch)}
                                    >
                                        {showAddBranch ? 'Zrušiť' : 'Pridať prevádzkareň'}
                                    </Button>
                                </div>

                                {showAddBranch && (
                                    <div className="border rounded p-3 mb-3">
                                        <Form.Group className="mb-2">
                                            <Form.Label>Názov prevádzkarne*</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="napr. Košice - Moldavská"
                                                value={newBranch.name}
                                                onChange={e => setNewBranch({ ...newBranch, name: e.target.value })}
                                                isInvalid={!!branchErrors.name}
                                            />
                                            <Form.Control.Feedback type="invalid">{branchErrors.name}</Form.Control.Feedback>
                                        </Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Ulica*</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Ulica a číslo"
                                                        value={newBranch.address.street}
                                                        onChange={e => setNewBranch({ ...newBranch, address: { ...newBranch.address, street: e.target.value } })}
                                                        isInvalid={!!branchErrors.street}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{branchErrors.street}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>PSČ*</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={isAbroad ? 'PSČ / ZIP' : '00000'}
                                                        value={newBranch.address.zip}
                                                        onChange={e => setNewBranch({ ...newBranch, address: { ...newBranch.address, zip: e.target.value } })}
                                                        isInvalid={!!branchErrors.zip}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{branchErrors.zip}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Mesto*</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Mesto"
                                                        value={newBranch.address.city}
                                                        onChange={e => setNewBranch({ ...newBranch, address: { ...newBranch.address, city: e.target.value } })}
                                                        isInvalid={!!branchErrors.city}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{branchErrors.city}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Krajina*</Form.Label>
                                                    {isAbroad ? (
                                                        <>
                                                            <CreatableSelect
                                                                options={COUNTRIES}
                                                                value={newBranch.address.country ? { value: newBranch.address.country, label: newBranch.address.country } : null}
                                                                onChange={option => setNewBranch({ ...newBranch, address: { ...newBranch.address, country: option ? option.value : '' } })}
                                                                placeholder="Vyhľadať alebo vybrať krajinu..."
                                                                formatCreateLabel={val => `Použiť: "${val}"`}
                                                                isClearable
                                                                noOptionsMessage={() => 'Žiadne výsledky'}
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        borderColor: branchErrors.country ? '#dc3545' : state.isFocused ? '#86b7fe' : '#ced4da',
                                                                        boxShadow: branchErrors.country ? '0 0 0 0.25rem rgba(220,53,69,.25)' : state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
                                                                        '&:hover': { borderColor: branchErrors.country ? '#dc3545' : '#86b7fe' }
                                                                    })
                                                                }}
                                                            />
                                                            {branchErrors.country && (
                                                                <div className="invalid-feedback d-block">{branchErrors.country}</div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Slovensko"
                                                                value={newBranch.address.country}
                                                                onChange={e => setNewBranch({ ...newBranch, address: { ...newBranch.address, country: e.target.value } })}
                                                                isInvalid={!!branchErrors.country}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{branchErrors.country}</Form.Control.Feedback>
                                                        </>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="primary" size="sm" onClick={handleAddBranch}>
                                            Uložiť prevádzkareň
                                        </Button>
                                    </div>
                                )}

                                {Array.isArray(currentClient.branches) && currentClient.branches.length === 0 && !showAddBranch && (
                                    <p className="text-muted small">Žiadne prevádzkarne. Sídlo firmy sa použije ako predvolená adresa.</p>
                                )}

                                {Array.isArray(currentClient.branches) && currentClient.branches.map(branch => (
                                    <div key={branch._id} className="border rounded p-2 mb-2">
                                        {branchToEdit?._id === branch._id ? (
                                            <div>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Názov prevádzkarne*</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={editBranchData.name}
                                                        onChange={e => setEditBranchData({ ...editBranchData, name: e.target.value })}
                                                        isInvalid={!!editBranchErrors.name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{editBranchErrors.name}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Ulica*</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={editBranchData.address.street}
                                                                onChange={e => setEditBranchData({ ...editBranchData, address: { ...editBranchData.address, street: e.target.value } })}
                                                                isInvalid={!!editBranchErrors.street}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{editBranchErrors.street}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>PSČ*</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder={isAbroad ? 'PSČ / ZIP' : '00000'}
                                                                value={editBranchData.address.zip}
                                                                onChange={e => setEditBranchData({ ...editBranchData, address: { ...editBranchData.address, zip: e.target.value } })}
                                                                isInvalid={!!editBranchErrors.zip}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{editBranchErrors.zip}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Mesto*</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={editBranchData.address.city}
                                                                onChange={e => setEditBranchData({ ...editBranchData, address: { ...editBranchData.address, city: e.target.value } })}
                                                                isInvalid={!!editBranchErrors.city}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{editBranchErrors.city}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Krajina*</Form.Label>
                                                            {isAbroad ? (
                                                                <>
                                                                    <CreatableSelect
                                                                        options={COUNTRIES}
                                                                        value={editBranchData.address.country ? { value: editBranchData.address.country, label: editBranchData.address.country } : null}
                                                                        onChange={option => setEditBranchData({ ...editBranchData, address: { ...editBranchData.address, country: option ? option.value : '' } })}
                                                                        placeholder="Vyhľadať alebo vybrať krajinu..."
                                                                        formatCreateLabel={val => `Použiť: "${val}"`}
                                                                        isClearable
                                                                        noOptionsMessage={() => 'Žiadne výsledky'}
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: editBranchErrors.country ? '#dc3545' : state.isFocused ? '#86b7fe' : '#ced4da',
                                                                                boxShadow: editBranchErrors.country ? '0 0 0 0.25rem rgba(220,53,69,.25)' : state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
                                                                                '&:hover': { borderColor: editBranchErrors.country ? '#dc3545' : '#86b7fe' }
                                                                            })
                                                                        }}
                                                                    />
                                                                    {editBranchErrors.country && (
                                                                        <div className="invalid-feedback d-block">{editBranchErrors.country}</div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={editBranchData.address.country}
                                                                        onChange={e => setEditBranchData({ ...editBranchData, address: { ...editBranchData.address, country: e.target.value } })}
                                                                        isInvalid={!!editBranchErrors.country}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{editBranchErrors.country}</Form.Control.Feedback>
                                                                </>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <div className="d-flex gap-2">
                                                    <Button variant="primary" size="sm" onClick={handleUpdateBranch}>
                                                        Uložiť zmeny
                                                    </Button>
                                                    <Button variant="outline-secondary" size="sm" onClick={() => { setBranchToEdit(null); setEditBranchData(null); }}>
                                                        Zrušiť
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <strong>{branch.name}</strong>
                                                    <div className="text-muted small">
                                                        {branch.address.street}, {branch.address.zip} {branch.address.city}
                                                    </div>
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <Button
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        onClick={() => handleStartEditBranch(branch)}
                                                    >
                                                        Upraviť
                                                    </Button>
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => setBranchToDelete(branch)}
                                                    >
                                                        Vymazať
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </Col>
                        </Row>

                        <Row style={{ position: 'sticky', bottom: 0, background: '#fff', paddingTop: '10px' }}>
                            <hr />
                            <Col className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-2">
                                    <Button
                                        variant="outline-danger"
                                        onClick={() => setShowDeleteModal(true)}
                                        disabled={!canDelete}
                                    >
                                        Vymazať
                                    </Button>
                                    {!canDelete && (
                                        <small className="text-muted">
                                            Nie je možné vymazať – odberateľ/dodávateľ je použitý v evidenčnom liste.
                                        </small>
                                    )}
                                </div>
                                <Button
                                    className='button-custom-large'
                                    variant='primary'
                                    type="submit"
                                    size="lg"
                                >
                                    Uložiť zmeny
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Potvrdenie vymazania</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Ste si istý, že chcete vymazať odberateľa/dodávateľa <b>{currentClient.companyName}</b>?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                Zrušiť
                            </Button>
                            <Button variant="danger" onClick={handleDelete}>
                                Vymazať
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={!!branchToDelete} onHide={() => setBranchToDelete(null)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Potvrdenie vymazania</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Ste si istý, že chcete vymazať prevádzkareň <b>{branchToDelete?.name}</b>?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setBranchToDelete(null)}>
                                Zrušiť
                            </Button>
                            <Button variant="danger" onClick={handleConfirmDeleteBranch}>
                                Vymazať
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )}
        </>
    );
};

export default EditClient;
